import { FocusableOption } from '@angular/cdk/a11y';
import { Component, ElementRef, HostBinding, Input } from '@angular/core';

import { CuttedMaterialPanel } from '../../../models/cutting/cutting-cutted-material-panel.model';

@Component({
  selector: '[csl-focusable-element]',
  template: '<ng-content></ng-content>',
})
export class FocusableElementComponent implements FocusableOption {
  @Input() item: CuttedMaterialPanel;

  @HostBinding('tabindex') tabindex = -1;

  constructor(private _elementRef: ElementRef) {}

  focus(): void {
    this._elementRef.nativeElement.focus();
  }
}
